import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,_vm._g(_vm._b({staticClass:"g-chip"},'v-chip',Object.assign({}, _vm.$attrs, {label: _vm.label, close: _vm.close, closeIcon: _vm.closeIcon}),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }